import { Box } from "@mui/material"

export default function LandingTop() {
  return (
    <>
      <h1 hidden>アウトソーシングテクノロジー　フリーランスついに、始動！</h1>
      <h2 hidden>この世界にある、あらゆる“はたらく”を革新する企業に。</h2>
      <Box
        component="img"
        src={"./assets/MV.png"}
        alt="メインの写真"
        sx={{ width: "100%" }}
      />
      {/* <Box>
        <Container>
          <Typography>アウトソーシングテクノロジー　フリーランス</Typography>
          <Typography>ついに、始動！</Typography>
          <Typography>
            この世界にある、あらゆる‟はたらく”を革新する企業に。
          </Typography>
        </Container>
      </Box> */}
    </>
  )
}
